var map = {
	"./asana.svg": "e833",
	"./bitbucket.svg": "508c",
	"./clickup.svg": "c69c",
	"./github.svg": "ac47",
	"./gitlab.svg": "375e",
	"./jira.svg": "9219",
	"./slack.svg": "7468"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e1b4";